import '../../App.css';
import React, { useContext, useEffect } from "react";
import { Form, Row, Col } from 'react-bootstrap';
import { FaTimes } from 'react-icons/fa';
import { StyleContext } from '../../context/StyleContext';
import { ServicoContext } from '../../context/ServicoContext';

function ModalCadastrarLocalidade({ closeModal, currentPage }) {
    const { CadastrarLocalidade, CadastroLocalidade, setCadastroLocalidade, Organizacoes, ListaOrganizacao } = useContext(ServicoContext)
    const { btnVer, btnCriar } = useContext(StyleContext)

    const handleChange = (event) => {
        setCadastroLocalidade({ ...CadastroLocalidade, [event.target.name]: event.target.value })
    }

    const handleClose = () => {
        setCadastroLocalidade({ nome: "", descricao: "", organizacaoKey: "" });
        closeModal(false);
    };

    useEffect(() => {
        ListaOrganizacao()
    }, [])

    return (
        <div className="modal-novo">
            <div className="modal-novo-interno">
                <div className="header-modal">
                    <h1 className="h1-modal">Cadastrar localidade</h1>
                    <div className="btn-close-modal" onClick={() => closeModal(false)}>
                        <FaTimes />
                    </div>
                </div>
                <form onSubmit={(e) => CadastrarLocalidade(e, currentPage)}>
                    <div className="modal-content">
                        <Row>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>Nome</Form.Label>
                                    <Form.Control maxLength={255} onChange={handleChange} name="nome" />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>Organização</Form.Label>
                                    <Form.Select aria-label="Default select example" onChange={handleChange} name="organizacaoKey">
                                        <option value="0">Selecione</option>
                                        {Organizacoes &&
                                            Organizacoes.sort((a, b) => a?.nome?.localeCompare(b?.nome))?.map((item) => {
                                                return (
                                                    <option key={item.id} value={item.key}>{item.nome.length > 120 ? item.nome.substring(0, 120) + '...' : item.nome}</option>
                                                )
                                            })

                                        }
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>Descrição</Form.Label>
                                    <Form.Control maxLength={255} onChange={handleChange} name="descricao" />
                                </Form.Group>
                            </Col>
                        </Row>
                    </div>
                    <div className="footer-modal-criar-demanda">
                        <button type="button" className="btn-dash btn-ver" style={btnVer} onClick={handleClose}>Cancelar</button>
                        <button className="btn-dash btn-criar" style={btnCriar}>Salvar</button>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default ModalCadastrarLocalidade